export const CATALOG_TEMPLATES = [
    {
        id: "bienvenida-simple",
        name: "Bienvenida simple",
        description:
            "Un texto de bienvenida para empezar a mostrar tu catálogo.",
        segments: [
            {
                type: "text",
                style: "titleCentered",
                title: "Bienvenido a nuestro catálogo",
                text: "Encuentra todo lo que buscas, actualizado siempre."
            }
        ]
    },
    {
        id: "historia-y-bienvenida",
        name: "Historia y bienvenida",
        description:
            "Un bloque de bienvenida y otro para contar la historia de tu negocio.",
        segments: [
            {
                type: "text",
                style: "titleCentered",
                title: "Bienvenido a nuestro catálogo",
                text: "Encuentra todo lo que buscas, actualizado siempre."
            },
            {
                type: "text",
                style: "titleText",
                title: "Nuestra historia",
                text: "Contale a tus clientes quién está detrás de tu negocio."
            }
        ]
    }
];

// Cada entrada, una vez el banco de imágenes compartidas tenga contenido
// real:
// {
//     id: "ver-ubicacion",
//     name: "Ver ubicación",
//     description: "Banner con la imagen de un mapa, enlaza a Google Maps.",
//     segmentType: "banners",
//     style: "v1",
//     imageId: 123, // id real de una Image con isShared: true
//     linkTitle: "Ver ubicación",
//     fields: [
//         {
//             key: "url",
//             label: "Link de Google Maps",
//             placeholder: "https://maps.app.goo.gl/...",
//             type: "url"
//         }
//     ]
// }
export const GUIDED_SEGMENT_TEMPLATES = [];
